<template>
  <div>
    <h1>
      Signup
    </h1>
    <form @submit.prevent="doSignup()">
      <input type="text" placeholder="name" v-model="name" />
      <input type="text" placeholder="username" v-model="username" />
      <input type="password" placeholder="password" v-model="password" />
      <!-- <input type="submit" value="Create Account" /> -->
      <button type="submit">SignUp</button>
      <router-link to="/login">Want to Login?</router-link>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      username: "",
      password: ""
    };
  },
  methods: {
    doSignup() {
      if (
        this.name.length > 3 &&
        this.username.length > 3 &&
        this.password.length > 3
      ) {
        this.axios.post("signup", {
          name: this.name,
          username: this.username,
          password: this.password
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    input {
      width: 200px;
      height: 20px;
      margin: 10px;
      padding: 3px;
      text-align: center;
    }
    button {
      width: 100px;
      margin: 10px;
      padding: 5px;
      font-weight: normal;
      font-size: 1em;
      letter-spacing: 0.5px;
      border: 1px transparent;
      border-radius: 5px;
      color: #f7f7f7;
      background-color: #2c3e50;
    }
  }
  a{
    text-decoration: none;
    color:#2c3e50;
    padding:5px;
  }
}
</style>
